export default __webpack_public_path__ + "static/media/prod-page-pintura.0821dc00.jpg";